import { useState, useCallback } from "react";

const useGeolocation = () => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getLocation = useCallback((options = {}) => {
    setLoading(true);
    setError("");

    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        setError("Geolocation is not supported.");
        setLoading(false);
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const data = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
          };

          setLocation(data);
          setLoading(false);

          resolve(data);
        },
        async (err) => {
          let message = "";

          switch (err.code) {
            case err.PERMISSION_DENIED:
              message = "Location permission denied.";
              break;

            case err.POSITION_UNAVAILABLE:
              message = "Location unavailable.";
              break;

            case err.TIMEOUT:
              message = "Location request timed out.";
              break;

            default:
              message = "Unable to fetch location.";
          }

          setError(message);
          setLoading(false);
          await options.onError?.(err);

          // Don't reject
          resolve(null);
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        }
      );
    });
  }, []);

  return {
    location,
    loading,
    error,
    getLocation,
  };
};

export default useGeolocation;
